import { EmployeeWhole } from '@/types';

import { RootState } from '../types';

export const selectViolationsPerEmployee = (id: EmployeeWhole['id']) => (state: RootState) =>
  state.reducer.workingRules.violationsPerEmployee[id];
